import React from "react";
import { Link } from "react-router-dom";

const links = [
  { label: "Home", to: "/" },
  { label: "Today's Result", to: "/" },
  { label: "Previous Result", to: "/previous-result/" },
  { label: "Common Number", to: "/common-number/" },
  { label: "Blog", to: "/blog/" },
  { label: "Teer Calendar", to: "/teer-calendar/" },
  { label: "About Us", to: "/about-us/" },
  { label: "Contact", to: "/contact-us/" },
  { label: "Privacy Policy", to: "/privacy-policy/" },
  { label: "Disclaimer", to: "/disclaimer/" },
  { label: "Terms & Conditions", to: "/terms-conditions/" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-10 bg-[#0c1622] text-slate-300"
    >
      <div className="mx-auto max-w-3xl px-4 py-8">
        <h2 className="text-lg font-bold text-white">Bhutan Morning Teer Result</h2>
        <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">
          Latest Bhutan Morning Teer FR &amp; SR results, previous results and
          common number updates. Results are published only after they are
          officially declared.
        </p>

        <nav className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
          {links.map((l, i) => (
            <Link
              key={`${l.to}-${i}`}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-sm text-slate-300 transition-colors hover:text-[#1ab5a3]"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="mt-6 border-t border-white/10 pt-4 text-xs text-slate-500">
          <p>
            Disclaimer: This website is for informational purposes only and is
            not associated with any government body. Please check your local
            laws before participating in any activity.
          </p>
          <p className="mt-2">
            © {new Date().getFullYear()} bhutanmorningteerresult.in — All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
